import { FormValue } from '@flatsy/types/Applications'
import { Options as ButtonsOptions } from '@flatsy/core/Form/ReactFormHooks/Field/Buttons/Type'
import i18n from '@flatsy/utils/translations'

export const projectCompanyCreation = (): ButtonsOptions[] => {
  return [
    {
      label: i18n.t('business_created'),
      value: FormValue.companyCreation.COMPANY_CREATED,
    },
    {
      label: i18n.t('business_in_the_process_of_being_set_up'),
      value: FormValue.companyCreation.COMPANY_IN_PROCESS,
    },
  ]
}
